<template>
  <EntitySingle
    :config="config"
    :entity.sync="entity"
    :edit-mode="false"
    @entityFetched="updateEntity"
  >
    <div class="mb-3 text-right noprint">
      <b-form-checkbox
        v-model="hideEmpty"
        inline
        switch
      >
        {{ $t('Hide empty fields') }}
      </b-form-checkbox>
    </div>
    <div v-if="ungrouppedSections.length">
      <div
        v-for="section in ungrouppedSections"
        :key="section.id"
      >
        <EntityEditSection
          :title="section.title"
          :module="config.module"
          :entity="entity"
          :form-fields="getSectionFields(section.id)"
        />
      </div>
    </div>
    <div v-if="sectionsGroups.length">
      <div
        v-for="group in sectionsGroups"
        :key="group.id"
      >
        <h1 class="mt-2 mb-1">
          {{ group.title }}
        </h1>
        <div
          v-for="section in groupSections(group.id)"
          :key="section.id"
        >
          <EntityEditSection
            :title="section.title"
            :module="config.module"
            :entity="entity"
            :form-fields="getSectionFields(section.id)"
          />
        </div>
      </div>
    </div>
    <div class="mb-3 text-right noprint">
      <b-button @click="printAnswer">
        <feather-icon
          icon="PrinterIcon"
          class="mr-50"
        />
        {{ $t('Print') }}
      </b-button>
    </div>
  </EntitySingle>
</template>

<script>
import EntityEditSection from '@/layouts/entity/EntityEditSection.vue'
import EntitySingle from '@/layouts/entity/EntitySingle.vue'
import { getUserRights } from '@/auth/utils'
import { translationUtils } from '@core/mixins/ui/translations'
import storeModule from './storeModule'

export default {
  components: {
    EntityEditSection,
    EntitySingle,
  },
  mixins: [translationUtils],
  data() {
    return {
      entity: {
        requestType: { id: 0 },
        fields: [],
        colSize: 3,
      },
      allFields: [],
      patientCodeRequired: true,
      hideEmpty: false,
      patientCodeTitle: null,
    }
  },
  computed: {
    requestTypeId() {
      return this.$route.params.rid
    },
    isManager() {
      return getUserRights().includes('Request_Type_Management_Request_Type_Edit')
    },
    config() {
      return {
        store: storeModule,
        module: 'submissions',
        endpoint: 'submissions',
        route: 'request-submissions',
        title: {
          single: this.$t('Request Type Add'),
          plural: this.$t('My Submissions'),
        },
      }
    },
    selectMultipleIds() {
      return (
        this.allFields
          .filter(field => field.type === 'SELECTMULTIPLE')
          .map(field => field.id) || []
      )
    },
    fields() {
      return [
        {
          id: 'comments',
          type: 'textarea',
          title: this.$t('comments'),
          size: 12,
        },
      ].map(field => ({ ...field, section: { title: this.$t('comments') } }))
    },
    sections() {
      return [
        ...new Set(this.allFields.map(item => JSON.stringify(item.section))),
      ].map(i => JSON.parse(i))
    },
    ungrouppedSections() {
      return this.sections.filter(item => item.group == null)
    },
    sectionsGroups() {
      return [
        ...new Set(this.sections.filter(item => item.group != null).map(item => JSON.stringify(item.group))),
      ].map(i => JSON.parse(i))
    }
  },
  methods: {
    async fetchFields(rId) {
      const response = await this.$store.dispatch('app-common/fetchRequestTypeFields', rId)
      this.allFields = [...response.data.fields, ...this.fields]
    },
    fieldHidden(field) {
      if (field.dependentField) {
        const val = field.dependentFieldValue
        const entityVal = this.entity[field.dependentField.id]
        const isMultiple = Array.isArray(entityVal)
        if (val.includes('!')) {
          if (isMultiple) {
            return !(entityVal && !entityVal.includes(val.replace('!', '')))
          }
          return entityVal == val.replace('!', '')
        } else if (val.includes(',')) {
          const arr = val.split(',')
          if (isMultiple) {
            return !(entityVal && entityVal.some(r => arr.includes(r)))
          }
          return !arr.includes(entityVal)
        }
        if (isMultiple) {
          return !(entityVal && entityVal.includes(val))
        }
        return entityVal != val
      }
      return this.hideEmpty && !this.entity[field.id]?.length
    },
    getSectionFields(sectionId) {
      return this.allFields
        .filter(item => item.section.id === sectionId)
        .map(field => {
          let type = field.type.toLowerCase()
          if (type != 'textarea') {
            type = 'text'
          }
          return {
            id: field.id,
            type,
            label: field.title,
            suffix: field.unit ? field.unit.title : null,
            extraClass: field.required ? 'required-field' : null,
            readonly: true,
            disabled: false,
            colSize: field.size,
            helpText: field.helpText,
            hideToggle: !this.isManager,
            hidden: this.fieldHidden(field),
          }
        })
    },
    async updateEntity(entity) {
      await this.fetchFields(this.entity.requestType.id)
      this.setEntity(entity)
      await this.$nextTick()
      setTimeout(() => {
        this.printAnswer()
      }, 1000)
    },
    setEntity(entity) {
      entity.fields.forEach(item => {
        const val = this.selectMultipleIds.includes(parseInt(item.field.id))
          ? item.value.split(',')
          : item.value
        this.entity[item.field.id] = val
      })
      this.entity.fields = []
    },
    printAnswer() {
      window.print()
    },
    groupSections(groupId) {
      return this.sections.filter(item => item.group != null && item.group.id == groupId)
    },
  },
}
</script>
